import { render, staticRenderFns, recyclableRender, components } from "./distribute.vue?vue&type=template&id=5fc47f58&"
var renderjs
import script from "./distribute.vue?vue&type=script&lang=js&"
export * from "./distribute.vue?vue&type=script&lang=js&"
import style0 from "./distribute.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!D:\\hbuliderx\\HBuilderX.3.3.11.20220209.full\\HBuilderX\\plugins\\uniapp-cli\\node_modules\\@dcloudio\\vue-cli-plugin-uni\\packages\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null,
  false,
  components,
  renderjs
)

component.options.__file = "oilDistribution/distribute/distribute.vue"
export default component.exports